export default __webpack_public_path__ + "static/media/Цинк_1л.6d6831b8.jpg";